package com.neurobs.react.semanticui

import com.neurobs.react.StyleUtil

import scala.scalajs.js

case class UiElementModifiers(elementModifiers: String, classString: String, styleAttributes: Seq[(String, js.Any)]) {
  def values = (elementModifiers, classString, styleAttributes)

  def formattedClassName(elementName: String) = s"ui $elementModifiers $elementName $classString"
  def createStyle = StyleUtil.makeStyle(styleAttributes:_*)

  def addModifier(modifier: String) = this.copy(s"$elementModifiers $modifier")
}

object UiElementModifiers {
  implicit val defaultModifiers = UiElementModifiers("", "", Seq())
  implicit def valuesToModifiers1(values: (String, String, Seq[(String, js.Any)])): UiElementModifiers = UiElementModifiers(values._1, values._2, values._3)
  implicit def valuesToModifiers2(values: (String, Seq[(String, js.Any)])): UiElementModifiers = UiElementModifiers(values._1, "", values._2)
  implicit def valuesToModifiers3(values: (String, String)): UiElementModifiers = UiElementModifiers(values._1, values._2, Seq())
  implicit def valuesToModifiers4(value: String): UiElementModifiers = UiElementModifiers(value, "", Seq())
  implicit def valuesToModifiers5(value: Seq[(String, js.Any)]) = UiElementModifiers("", "", value)
}
